
export default {
    SET_VARIABLE_PIXEL_DATA: function (state, pixelData) {
        state.variablePixelData = pixelData.data;
    },
    SET_PIXEL_DATA_LOADING: function (state, status) {
        state.pixelDataLoading = status;
    },
    SET_LAST_PIXEL_DATA: function (state, pixelData) {
        state.pixelDataLast = pixelData;
    },
    SET_HISTORICAL_PIXEL_DATA: function (state, data) {

        if (data.length > 0) {

            const map = new Map();
            
            if (state.pixelDataHis.length > 0) {
                state.pixelDataHis.forEach(item => map.set(item.date, item));
                data.forEach(item => {
                    map.set(item.date, {...map.get(item.date), ...item})
                    //arr2.forEach(item => map.set(item.date, {...map.get(item.date), ...item}));
                });
                state.pixelDataHis = [];
                Array.from(map.values()).forEach(item => {
                    state.pixelDataHis.push(item);
                });
            } else {

                state.pixelDataHis = data;

                // let arr1 = data.shift();
                // console.log('arr1; ', arr1)
                // arr1.forEach(item => map.set(item.date, item));
                // data.forEach(arr2 => {
                //     arr2.forEach(item => map.set(item.date, {...map.get(item.date), ...item}));
                // });
            }
            
            

        } else {
            // Clear array
            state.pixelDataHis = [];
        }

    }
}
